import { TrackingEvent } from '@mkp/tracking/models';
import { User } from '@mkp/user/models';
import { createActionGroup, emptyProps, props } from '@ngrx/store';

export const TrackingActions = createActionGroup({
  source: 'Tracking',
  events: {
    'Load Tealium Start': emptyProps(),
    'Load Tealium Success': emptyProps(),
    'Load Tealium Failed': emptyProps(),
    'Send Pure Frontend Event': props<TrackingEvent>(),
    'Send Registration Event': props<User>(),
    'Send Job Ad Create Start Event': emptyProps(),
    'Send Open Logo Guidelines Event': emptyProps(),
    'Track Boost Button Click': emptyProps(),
  },
});
